import useQueryUserTier from '@/hooks/query/useQueryUserTier';
import { getTeamMembersWithRelationship } from '@/pages/api/scribeAPIV2';
import { GET_TEAM_MEMBERS_WITH_RELATIONSHIP } from '@heidi/workspace/contracts';
import { useQuery } from '@tanstack/react-query';
import { useQueryUser } from './useQueryUser';

// The cache identity moved to `@heidi/workspace/contracts` (OT4, ARCFE-1033)
// so the two headless write hooks that invalidate against it can reach it from
// package `/data`. Re-exported (not re-declared) so existing importers of this
// path keep resolving unchanged — one declaration site, one cache.
export { GET_TEAM_MEMBERS_WITH_RELATIONSHIP };

export function useQueryTeamMembersWithRelationship(teamId?: string) {
  const { data: userData } = useQueryUser();
  const { userTier, isTogetherOrHigherTier } = useQueryUserTier();

  return useQuery({
    queryKey: [GET_TEAM_MEMBERS_WITH_RELATIONSHIP, { teamId }],
    enabled: !!userData && !!teamId && !!userTier && isTogetherOrHigherTier,
    // Member list must update on focus when an invitee accepts or someone is
    // removed. The global 1h staleTime would otherwise block refetchOnWindowFocus.
    // Only mounted while viewing a team, so a short staleTime is cheap.
    // See APP-5390 / APP-5396.
    staleTime: 60 * 1000,
    queryFn: async () => {
      const { data } = await getTeamMembersWithRelationship(teamId!);
      return data;
    },
  });
}
